import { Injectable } from '@angular/core';
import { IAnnotation, IAnnotationAttachment } from 'src/app/model/thingie/annotation';
import { IThingie } from 'src/app/model/thingie/thingie';
import { IAttachmentLocation, ICreateAnnotationsResult, ThingieService } from './thingie-service.service';

@Injectable({
  providedIn: 'root',
  useExisting: ThingieService
})
export abstract class AnnotationService {

  /**
   * Create and add all provided annotations to all thingies
   * provided as Thingie-IDs
   *
   * @param thingies List of Thingie-IDs
   * @param annotations The annotations to create
   */
  public abstract createAnnotations(
    opt: { thingies: string[]; annotations: IAnnotation[] }
  ): Promise<ICreateAnnotationsResult>;

  public abstract saveAnnotations(thingieId: string, annotation: IAnnotation): Promise<IThingie>;

  public abstract editAnnotation(thingieId: string, annotationId: number, annotation: IAnnotation): Promise<IThingie>;

  public abstract uploadAttachment(thingieId: string, annotationId: number, file: File[]): Promise<IAnnotationAttachment[]>;

  /**
   * Marks the attachments identified by the parameter as deleted.
   *
   * @param attachmentLocations The locations of attachment to delete
   * @returns Promise which resolves once the attachments are deleted, rejects otherwise
   */
  public abstract removeAttachments(attachmentLocations: IAttachmentLocation[]): Promise<void>;

  /**
   * Creates a zip file containing all attachments identified by the parameter.
   *
   * @param hashes of the attachments to include in the ZIP file
   * @returns the URI linking to the file
   */
  public abstract createAttachmentZipFile(attachmentHashes: string[]): Promise<string>;

  /**
   * Sets the deleted flag of the attachments identified by the parameter to false.
   *
   * @param attachmentLocations The locations of attachments to "undelete"
   */
  public abstract undeleteAttachments(attachmentLocations: IAttachmentLocation[]): Promise<void>;

  public abstract downloadAnnotationAttachment(annotationAttachment: IAnnotationAttachment): Promise<void>;

  public abstract deleteAnnotations(thingieId: string, annotationId: number): Promise<IThingie>;
}
